import * as React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Popover } from 'react-bootstrap';

export interface ProjectSidebarComponentProps {
  isLogged: boolean;
  interestedUser: boolean;
  investedUser: boolean;
  projectFounded: boolean;
  projectFormalization: boolean;
  projectStatus: string;
  activePayment: boolean;
  isPaid: boolean;
  section: string;
  closedProject: boolean;
  handleClick: (value: string) => void;
  handleInterested: () => void;
}

class ProjectSidebarComponent extends React.PureComponent<ProjectSidebarComponentProps> {

  public render(): React.ReactNode {

    const popoverBottom = (
      <Popover
        id="popover-positioned-bottom"
        className="popover-interested"
      >
        <p>
          <strong>
            <em>
              Para acceder a toda la información disponible, tienes que seleccionar la opción “Me Interesa”.
            </em>
          </strong> Recuerda que toda la información a la que tengas acceso, que no aparezca en la sección pública,
          está sujeta a la obligación de confidencialidad y secreto recogida en el apartado 5.a) de los&nbsp;
          <Link to="/terminos-y-condiciones">términos y condiciones particulares de uso</Link>&nbsp;que aceptaste
          durante el registro como usuario.
        </p>
        <button
          className="btn btn-primary margin-r-10"
          onClick={() => this.props.handleInterested()}
        >
          Me interesa
        </button>
      </Popover>
    );

    let paymentTabClass = this.props.section === 'payment' ? 'active' : '';
    let paymentIconClass = 'wallet';
    if (!this.props.isPaid) {
      paymentTabClass = paymentTabClass + ' payment-alert';
      paymentIconClass = 'wallet warning';
    }
    
    return (
      <div className="col-sm-3 border-right-inset-shadow text-right padding-l-r-0">
        <ul className="sidebar-project sidebar-project-preview">
          {
            this.props.isLogged && this.props.investedUser && !this.props.projectFounded ?
              (
                <li
                  className={this.props.section === 'formalize' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('formalize')}
                >
                  <span className="formalization"/> Formalizar operación
                </li>
              ) :
              null
          }
          {this.props.isLogged && this.props.investedUser && !this.props.projectFounded && this.props.activePayment ?
            (
              <li
                className={paymentTabClass}
                onClick={() => this.props.handleClick('payment')}
              >
                <span className={paymentIconClass}/> Realizar desembolso
              </li>) :
            null
          }
          <li
            key="summary"
            className={this.props.section === 'resumen' ?
              'active' :
              ''
            }
            onClick={() => this.props.handleClick('resumen')}
          >

            <span className="resume"/> Resumen
          </li>
          {
            this.props.isLogged &&
            !this.props.interestedUser &&
            !this.props.projectFounded &&
            !this.props.projectFormalization &&
            !this.props.closedProject ?
              [
                <OverlayTrigger
                  key="business-model"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="go"/> Modelo de negocio
                  </li>
                </OverlayTrigger>,
                <OverlayTrigger
                  key="market"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="market"/> Mercado
                  </li>
                </OverlayTrigger>,
                <OverlayTrigger
                  key="metrics"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="metrics"/> Métricas
                  </li>
                </OverlayTrigger>,
                <OverlayTrigger
                  key="competitive-environment"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="environment"/> Datos Financieros
                  </li>
                </OverlayTrigger>,
                <OverlayTrigger
                  key="details"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="details"/> Detalles de la ronda
                  </li>
                </OverlayTrigger>,
                <OverlayTrigger
                  key="team"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="team"/> Equipo
                  </li>
                </OverlayTrigger>,
                <OverlayTrigger
                  key="docs"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="docs"/> Documentos
                  </li>
                </OverlayTrigger>,
                <OverlayTrigger
                  key="investors"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="inv"/> Inversores
                  </li>
                </OverlayTrigger>,
                <OverlayTrigger
                  key="interested"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="interested"/> Interesados
                  </li>
                </OverlayTrigger>,
                <OverlayTrigger
                  key="comments"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={popoverBottom}
                >
                  <li className="disabled-tab">
                    <span className="comments"/> Comentarios
                  </li>
                </OverlayTrigger>
              ] :
              null
          }
          {
            this.props.isLogged &&
            this.props.interestedUser &&
            !this.props.projectFounded &&
            !this.props.projectFormalization ?
              [
                <li
                  key="business-model"
                  className={this.props.section === 'modelo-de-negocio' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('modelo-de-negocio')}
                >
                  <span className="go"/> Modelo de negocio
                </li>,
                <li
                  key="market"
                  className={this.props.section === 'mercado' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('mercado')}
                >
                  <span className="market"/> Mercado
                </li>,
                <li
                  key="metrics"
                  className={this.props.section === 'metricas' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('metricas')}
                >
                  <span className="metrics"/> Métricas
                </li>,
                <li
                  key="financial-data"
                  className={this.props.section === 'datos-financieros' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('datos-financieros')}
                >
                  <span className="environment"/> Datos Financieros
                </li>,
                <li
                  key="details"
                  className={this.props.section === 'detalles' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('detalles')}
                >
                  <span className="details"/> Detalles de la ronda
                </li>,
                <li
                  key="team"
                  className={this.props.section === 'equipo' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('equipo')}
                >
                  <span className="team"/> Equipo
                </li>,
                <li
                  key="docs"
                  className={this.props.section === 'documentos' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('documentos')}
                >
                  <span className="docs"/> Documentos
                </li>,
                <li
                  key="investors"
                  className={this.props.section === 'inversores' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('inversores')}
                >
                  <span className="inv"/> Inversores
                </li>,
                <li
                  key="interested"
                  className={this.props.section === 'interesados' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('interesados')}
                >
                  <span className="interested"/> Interesados
                </li>,
                <li
                  key="comments"
                  className={this.props.section === 'comentarios' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('comentarios')}
                >
                  <span className="comments"/> Comentarios
                </li>
              ] :
              null
          }
          {
            this.props.isLogged &&
            this.props.investedUser &&
            (this.props.projectFounded || this.props.projectFormalization) ?
              [
                <li
                  key="details"
                  className={this.props.section === 'detalles' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('detalles')}
                >
                  <span className="details"/> Detalles de la ronda
                </li>,
                <li
                  key="team"
                  className={this.props.section === 'equipo' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('equipo')}
                >
                  <span className="team"/> Equipo
                </li>,
                <li
                  key="docs"
                  className={this.props.section === 'documentos' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('documentos')}
                >
                  <span className="docs"/> Documentos
                </li>,
                (this.props.projectFounded ?
                    < li
                      key="quarterly-reports"
                      className={
                        this.props.section === 'quarterly-reports' ?
                          'active' :
                          ''
                      }
                      onClick={() => this.props.handleClick('quarterly-reports')}
                    >
                      <span className="quarterly-reports"/> Informes de seguimiento
                    </li> : null
                )

                ,
                <li
                  key="investors"
                  className={this.props.section === 'inversores' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('inversores')}
                >
                  <span className="inv"/> Inversores
                </li>,
                <li
                  key="comments"
                  className={this.props.section === 'comentarios' ?
                    'active' :
                    ''
                  }
                  onClick={() => this.props.handleClick('comentarios')}
                >
                  <span className="comments"/> Comentarios
                </li>,
              ] :
              null
          }
        </ul>
      </div>
    );
  }
}

export default ProjectSidebarComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/ProjectSidebar.component.tsx